export default __webpack_public_path__ + "static/media/csv.be200c08.png";